export type AssistantCatalogAuthorityResult<T> = {
  items: T[];
  error: string | null;
};

export const resolveAssistantCatalogFixtureSeed = <T>(input: {
  localFixture: T[];
  useLocalCatalogFixture?: boolean;
}): T[] => (
  input.useLocalCatalogFixture ? input.localFixture : []
);

export const resolveAuthorizedAssistantCatalogSuccess = <T>(
  authorizedItems: T[],
): AssistantCatalogAuthorityResult<T> => ({
  items: authorizedItems,
  error: null,
});

export const resolveAuthorizedAssistantCatalogFailure = <T>(input: {
  localFixture: T[];
  useLocalCatalogFixture?: boolean;
  errorMessage: string;
}): AssistantCatalogAuthorityResult<T> => ({
  items: resolveAssistantCatalogFixtureSeed(input),
  error: input.errorMessage,
});
